import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../components/site';
import type { SolutionStatsRibbon } from './types';

function RibbonDecor() {
  return (
    <div className="hosp-stats-ribbon__decor" aria-hidden>
      <svg className="hosp-stats-ribbon__decor-wifi" viewBox="0 0 24 24" fill="none">
        <path d="M2.5 8.5a14 14 0 0 1 19 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M5.5 11.5a10 10 0 0 1 13 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="12" cy="18" r="1.25" fill="currentColor" />
      </svg>
      <svg className="hosp-stats-ribbon__decor-cloud" viewBox="0 0 24 24" fill="none">
        <path
          d="M7 18h10a4 4 0 0 0 .4-8 5.5 5.5 0 0 0-10.6 1.8A3.5 3.5 0 0 0 7 18Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
      <svg className="hosp-stats-ribbon__decor-graph" viewBox="0 0 24 24" fill="none">
        <path d="M4 18V6M4 18h16M8 14l3-4 3 2 4-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
}

export const SolutionHospitalityStatsRibbon: React.FC<{
  ribbon: SolutionStatsRibbon;
}> = ({ ribbon }) => (
  <SiteSection id="trust-scale" className="hosp-stats-ribbon">
    <RibbonDecor />
    <SiteSectionHeader
      eyebrow={ribbon.eyebrow}
      title={ribbon.title}
      subtitle={ribbon.subtitle}
      align="center"
    />

    <div className="hosp-stats-ribbon__shell">
      <div className="hosp-stats-ribbon__strip" role="list" aria-label={ribbon.title}>
        {ribbon.items.map((item, index) => (
          <React.Fragment key={item.label}>
            {index > 0 ? (
              <span className="hosp-stats-ribbon__sep" aria-hidden>
                ●
              </span>
            ) : null}
            <div
              className={`hosp-stats-ribbon__stat${
                item.value.length > 10 ? ' hosp-stats-ribbon__stat--compact' : ''
              }`}
              role="listitem"
            >
              <span className="hosp-stats-ribbon__stat-emoji" aria-hidden>
                {item.emoji}
              </span>
              <span className="hosp-stats-ribbon__stat-value">{item.value}</span>
              <span className="hosp-stats-ribbon__stat-label">{item.label}</span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  </SiteSection>
);
